import type { TerminalLossTransfer, CashTransferStatus } from '@/generated/graphql';

import { IAdmin, mapGQLAdmin } from './admin';
import { ICashier, mapGQLCashier } from './cashier';

export interface ITerminalLossTransfer {
  id: string;
  amount: number;
  status: CashTransferStatus | string;
  createdAt: string;
  updatedAt: string;

  admin: IAdmin;
  cashier: ICashier;
}

export interface ITerminalLossTransferTable {
  id: string;
  amount: number;
  status: CashTransferStatus | string;
  createdAt: string;
  cashierUsername: string;
  adminUsername: string;
}

export interface ITerminalLossTransferQueryVariable {
  first: number;
  after?: string;
  before?: string;
}

export function mapGQLTerminalLossTransfer(gql_terminalLossTransfer?: TerminalLossTransfer | null): ITerminalLossTransfer {
  return {
    id: gql_terminalLossTransfer?.id ?? '',
    amount: gql_terminalLossTransfer ? gql_terminalLossTransfer.amount ?? 0 : 0,
    status: gql_terminalLossTransfer ? gql_terminalLossTransfer.status ?? '' : '',

    updatedAt: gql_terminalLossTransfer ? gql_terminalLossTransfer.updatedAt ?? new Date().toISOString() : new Date().toISOString(),
    admin: mapGQLAdmin(gql_terminalLossTransfer?.admin),
    cashier: mapGQLCashier(gql_terminalLossTransfer?.cashier),
    createdAt: gql_terminalLossTransfer
      ? new Date(gql_terminalLossTransfer.createdAt).toLocaleString('en-US', {
          timeZone: 'Asia/Manila',
          month: '2-digit',
          day: '2-digit',
          year: 'numeric',
          hour12: true,
          minute: '2-digit',
          hour: '2-digit',
        }) ?? ''
      : '',
  };
}
